// extracted by mini-css-extract-plugin
export default {"contentWrap":"CompanyInfo_contentWrap__lvQgb","bgImage":"CompanyInfo_bgImage__3g1nb","textBand":"CompanyInfo_textBand__5HAkh"};